import { Model } from 'modules/core/lib/mobx-rest'

export interface ICompanyInstallation {
  author_id: string
  form_data: string
  integration_id: number
  company_id: number
  access_id: number
}

class CompanyInstallation extends Model<ICompanyInstallation> {
  static urlRoot() {
    return '/api/rest/marketplace/company_installation'
  }
}

export default CompanyInstallation
